import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
export function Hero() {
  const [index, setIndex] = useState(0);
  const keywords = ["Impact", "Visibilité", "Conversion", "Notoriété"];
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % keywords.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [keywords.length]);
  return (
    <section className="relative min-h-screen flex items-center pt-24 md:pt-32 pb-12 overflow-hidden bg-white">
      {/* Decorative Gradients */}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[600px] h-[600px] bg-brand-purple/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-[500px] h-[500px] bg-brand-lime/50 rounded-full blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="z-20"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-purple/5 border border-brand-purple/10 text-brand-purple text-xs font-semibold mb-8">
              <Sparkles className="w-3 h-3 text-brand-lime" />
              <span>L'agence digitale de référence au Sénégal</span>
            </div>
            <div className="min-h-[14rem] sm:min-h-[12rem] md:min-h-[18rem] flex flex-col justify-start">
              <h1 className="text-5xl sm:text-6xl md:text-7xl font-display font-extrabold text-brand-purple leading-[1.05] mb-6">
                Propulsez votre <br />
                <span className="relative inline-block text-transparent bg-clip-text bg-gradient-to-r from-brand-purple to-purple-600">
                  Vision Digitale
                </span>
                <br />
                <span className="text-brand-lime inline-flex items-center gap-2 whitespace-nowrap">
                  pour plus d'
                  <span className="relative inline-block min-w-[120px] md:min-w-[180px] overflow-hidden align-bottom ">
                    <AnimatePresence mode="wait">
                      <motion.span
                        key={keywords[index]}
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -20, opacity: 0 }}
                        transition={{ duration: 0.5 }}
                        className="inline-block whitespace-nowrap text-transition-smooth"
                      >
                        {keywords[index]}
                      </motion.span>
                    </AnimatePresence>
                  </span>
                </span>
              </h1>
            </div>
            <p className="text-lg md:text-xl text-brand-purple/70 max-w-lg mb-12 leading-relaxed text-pretty">
              Nous fusionnons créativité stratégique et innovation technologique pour créer des expériences digitales mémorables qui transforment votre entreprise.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" variant="default" className="group bg-brand-purple text-white hover:bg-brand-purple-light rounded-full px-6" asChild>
                <a href="#contact">
                  Demander un devis
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </a>
              </Button>
              <Button variant="outline" size="lg" className="border-brand-purple/20 text-brand-purple hover:bg-brand-purple/5 rounded-full" asChild>
                <a href="#services">Nos Services</a>
              </Button>
            </div>
            <div className="mt-16 flex items-center gap-6 text-sm text-brand-purple/60">
              <div className="flex -space-x-3">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="w-10 h-10 rounded-full border-2 border-white bg-gray-100 flex items-center justify-center overflow-hidden shadow-sm">
                    <img src={`https://i.pravatar.cc/100?u=${i + 20}`} alt="Client" className="w-full h-full object-cover" />
                  </div>
                ))}
              </div>
              <p className="font-medium">Rejoint par +50 entreprises au Sénégal</p>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="relative hidden lg:block"
          >
            {/* Background elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-brand-lime rounded-2xl -z-10 animate-pulse opacity-50" />
            {/* Floating Card - Repositioned to the right side to avoid title overlap */}
            <motion.div
              initial={{ x: 20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 1, duration: 0.6 }}
              className="absolute -bottom-10 -right-10 p-6 bg-white rounded-2xl shadow-xl border border-gray-100 z-20"
            >
               <div className="flex items-center gap-3">
                 <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                    <div className="w-3 h-3 rounded-full bg-green-500" />
                 </div>
                 <div>
                    <div className="text-[10px] text-gray-500 font-bold uppercase tracking-wider">Campagne active</div>
                    <div className="text-sm font-bold text-brand-purple">+124% Engagement</div>
                 </div>
               </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}